(function () {
  class PotBonusIntroAnim extends PIXI.Container {
    constructor() {
      super();

      this._fireballs = [];
      this._fireballsFinished = 0;
      this._fireballsIndex = 0;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    onGameConfigEvent() {
      for (let reel = 0; reel < 4; ++reel) {
        for (let row = 0; row < gameData.numRows; ++row) {
          const fireball = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball"
          );
          this._fireballs.push(fireball);
        }
      }
    }

    animate(callback) {
      this._callback = callback;

      this._fireballsFinished = 0;
      this._fireballsIndex = 0;

      this._fireballs.sort(function (a, b) {
        return 0.5 - Math.random();
      });

      this._fireballs.forEach((fireball) => {
        fireball.visible = true;
      });

      this.fireFireball();
    }

    fireFireball() {
      const self = this;

      this._fireballsIndex++;

      if (++self._fireballsFinished >= self._fireballs.length) {
        self._callback();
      }

      if (this._fireballsIndex < this._fireballs.length) {
        timerManager.addTimeout(100, function () {
          self.fireFireball();
        });
      }
    }

    reset() {
      this._fireballs.forEach(function (fireball) {
        fireball.visible = false;
      });
    }
  }

  var potBonusIntroAnimCreator = function (json) {
    return new PotBonusIntroAnim();
  };

  var potBonusIntroAnimInitialiser = function (json, potBonusIntroAnim) {};

  var potBonusIntroAnimFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "potBonusIntroAnim",
    potBonusIntroAnimCreator,
    potBonusIntroAnimInitialiser,
    potBonusIntroAnimFilesRequired
  );
})();
